import { client, deserializer } from 'services/client'
import { toSnake } from 'change-object-case'

export async function getEmailAccounts(params = {}) {
  const response = await client().get('/v2/email/accounts/admin_index', { params: toSnake(params) })
  return deserializer.deserialize(response)
}

export function disconnectEmailAccount(accountId) {
  return client().put(`/v2/email/accounts/${accountId}/admin_archive`)
}
